import React from 'react';
import { set, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { usePlanningBottomupState } from '../Context/index';
import { planningSeelingPath, FPKeysPath } from '../TablesFieldPath';
import useMonthlyPlanningHooks from '../Hooks/MonthlyPlanSellingHooks';
import useFPSalesHooks from '../Hooks/FPSalesHooks';
import useTerminalCalculationHooks from '../Hooks/useTerminalCalculationHooks';
import useMdCalculationHooks from '../Hooks/MdHooks';

export function MonthlyPlanSell() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel } = planningBottomup;
  const { monthlySell, caluculateTotalPWS } = useMonthlyPlanningHooks();
  const { caluculateFPSSales } = useFPSalesHooks();
  const { calculateTerminal } = useTerminalCalculationHooks();
  const { calculateMd } = useMdCalculationHooks();
  const { t } = useTranslation('common');

  const level = selectedLevel?.level;

  const handleCheckChange = async (value, path, index, keyName) => {
    const copyState = planningBottomProducts;
    set(copyState, path, value);
    const currenObj = get(copyState, index);
    const totalPWS = await caluculateTotalPWS(currenObj);
    if (level < 5) {
      set(copyState, `[${index}].isChanged`, true);
    }
    // return
    set(copyState, planningSeelingPath(index).PLANNING_SELLING_TOTALPWS, totalPWS);
    if (level >= 6) {
      let currenObj1 = get(copyState, index);
      const { fpSalesUnits, fpSalesValue } = await caluculateFPSSales(currenObj1);
      currenObj1 = { ...currenObj1, fpSalesUnits, fpSalesValue };
      set(copyState, FPKeysPath(index).FP_SALES_UNIT, fpSalesUnits);
      set(copyState, FPKeysPath(index).FP_SALES_VALUES, fpSalesValue);
      currenObj1 = await calculateMd(currenObj1);
      copyState[index] = await calculateTerminal(currenObj1, level);
    }

    if (level === 5) {
      copyState[index].existingPlanSelling = copyState[index]?.existingPlanSelling.map((exist) => {
        exist[keyName] = value;
        return exist;
      });
    }

    setPlanningBottomup((prevState) => ({
      ...prevState,
      planningBottomProducts: copyState,
    }));
  };
  const disabledArray = [7, 8];

  return (
    <>
      {checkVisibleBottomUp('planSelling') && (
        <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
          <thead>
            <tr>
              {monthlySell.map((monthItem, i) => {
                return (
                  <th key={i} className="w-200px">
                    <span>{t(`${monthItem.name}`)}</span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {planningBottomProducts?.map((trItem, iParent) => {
              const currPlanningSell = trItem?.planSelling;
              return (
                currPlanningSell && (
                  <tr key={iParent}>
                    {monthlySell?.map((tdItem, iTD) => {
                      return (
                        <td key={iTD} className={tdItem.keyName === 'totalPWS' ? 'text-right' : 'text-center'}>
                          {tdItem.keyName === 'totalPWS' ? (
                            <>{trItem[tdItem.keyName] || 0}</>
                          ) : (
                            <div className="checkbox-label d-inline-block planning">
                              <input
                                type="checkbox"
                                // name={`checks_${iTD}`}
                                id={`checks_${iParent}_${iTD}`}
                                checked={currPlanningSell[tdItem.keyName]}
                                onChange={(e) =>
                                  handleCheckChange(e.target.checked, planningSeelingPath(iParent, tdItem.keyName).PLANNING_SELLING, iParent, tdItem.keyName)
                                }
                                disabled={disabledArray.includes(level) || !planningBottomup?.addEditBottomAccess}
                                style={disabledArray.includes(level) || !planningBottomup?.addEditBottomAccess ? { cursor: 'not-allowed' } : {}}
                              />

                              <label
                                htmlFor={`checks_${iParent}_${iTD}`}
                                className={disabledArray.includes(level) || !planningBottomup?.addEditBottomAccess ? 'chklabel disabled' : 'chklabel'}
                              >
                                <span />
                              </label>
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
export default MonthlyPlanSell;
